module.exports = __webpack_public_path__ + "img/Shopicon.8bc17cfa.svg";